(function () {
    'use strict';

    var imageSliders = document.querySelectorAll('.org-numbers-block');

    for (var i = 0; i < imageSliders.length; i++) {
        var swiperContainer =
            imageSliders[i].querySelector('.swiper');

        const progressTop = imageSliders[i].querySelector(
            '.slider-progress-top'
        );
        const progressBottom = imageSliders[i].querySelector(
            '.slider-progress-bottom'
        );

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            watchOverflow: true,
            effect: 'fade',
            allowTouchMove: false,
            autoplay: {
                delay: 3000,
            },
            on: {
                // Slider index has a gradient
                afterInit: function () {
                    progressTop.style.height = `${
                        (100 / 3) * this.activeIndex
                    }%`;
                    progressBottom.style.height = `${
                        (100 / 3) *
                        (this.slides.length - (this.activeIndex + 1))
                    }%`;
                },
                slideChange: function () {
                    progressTop.style.height = `${
                        (100 / 3) * this.activeIndex
                    }%`;
                    progressBottom.style.height = `${
                        (100 / 3) *
                        (this.slides.length - (this.activeIndex + 1))
                    }%`;
                },
            },
        });
    }
})();
